import * as React from 'react';
import path from 'lodash/fp/path';
import {RouteChildrenProps} from 'react-router-dom';
import {FieldInput} from '@practicegenius/pg-ui/src/base/Material/components/FieldInput';
import {FormScreen} from '../../../components/screens/FormScreen';
import {EmailInput} from '../../../shared/Material/components/EmailFieldInput';
import {bottomText} from '../layout';
import {forgotPassword} from '../../../http/login';
import {routes} from '../routes';
import {useQueryParams} from '../../../utils/custom-hooks';
import {
  InvalidTokenReason,
  InvalidResetTokenModal,
} from './InvalidResetTokenModal';
import {queryStringToObject} from '../../../shared/utils/queryParams';
import {LoginSupportFooter} from '../../../components/LoginSupportFooter';

export function ForgotPassword({
  submit,
  history,
  ...otherProps
}: RouteChildrenProps & {
  submit: (a: any) => Promise<unknown>;
}) {
  const params = queryStringToObject();
  const initialLogin = params.user || '';
  const {invalidToken, invalidTokenHint} = useQueryParams<{
    invalidToken?: InvalidTokenReason;
    invalidTokenHint?: string;
  }>();

  const [invalidModal, setInvalidModal] = React.useState<
    null | undefined | InvalidTokenReason
  >(invalidToken);

  const onSubmit = React.useCallback(
    async (data: {email: string}) => {
      await submit(data);
      history.push(routes.login.forgotPasswordEmailSent, data);
    },
    [submit, history],
  );

  return (
    <>
      <FormScreen
        helmetTitle="Forgot Password"
        submit={onSubmit}
        submitText="Send"
        initialValues={{
          username_or_email:
            invalidTokenHint ||
            initialLogin ||
            path(['location', 'state', 'login'], otherProps),
        }}
        headerTitle="Forgot Password"
        title="Let's get you into your Account"
        instructions="Enter your username or the email address you used to register. We will send you an email with a link to reset your password."
        bottomText={
          <>
            {bottomText('password')}
            <LoginSupportFooter />
          </>
        }
      >
        <FieldInput
          name="username_or_email"
          label="Email or Username"
          component={EmailInput}
          autoFocus
        />
      </FormScreen>
      {invalidModal && (
        <InvalidResetTokenModal
          open={Boolean(invalidModal)}
          close={() => setInvalidModal(null)}
          reason={invalidModal}
        />
      )}
    </>
  );
}

ForgotPassword.defaultProps = {
  submit: forgotPassword,
};
